module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/G+P Large Area Sensor and OIS Camera.e60c6d18.png";